import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutTransmissionControlExpanded } from "./autogen/AutogenLayoutTransmissionControlExpanded";
import { ClickEvent, Component, Layout, TableRow } from "@mcleod/components";
import { TransmissionControlModal } from "./TransmissionControlModal";
import { EdiRawDataSlideout } from "./EdiRawDataSlideout";

export class TransmissionControlExpanded extends AutogenLayoutTransmissionControlExpanded {
    private _interchangeId: string;
    private _logId: string;
    private _description: string;

    override onLoad(): void {
        this.setupLayout();
    }

    initialize() {
        this.setupLayout();
    }

    afterExectutionTranset() {
        this.labelTransTotal.text = this.sourceEdiTransSet.data.length as unknown as string;
    }

    afterExectutionFunctionGrp() {
        this.labelFuncTotal.text = this.sourceEdiFunctionalGrp.data.length as unknown as string;
    }

    onDetailClick() {
        const layout = Layout.getLayout("lme/datafusion/TransmissionControlModal") as TransmissionControlModal;
        layout.addLayoutLoadListener(() => {
            layout.textboxDescription.text = this.description;
        });
        CommonDialogs.showDialog(layout, { title: "Detail Logging" });
    }

    onAllRawDataButtonClick() {
        EdiRawDataSlideout.openSlideout({title: 'Interchange Raw Data', interchangeId: this.interchangeId, selectAllInterchange: true});
    }

    onFuncGrpRawDataButtonClick(event: ClickEvent) {
        this.openSlideoutWithTabset(event, false);
    }

    onTransSetRawDataButtonClick(event: ClickEvent) {
        this.openSlideoutWithTabset(event, true);
    }

    private openSlideoutWithTabset(event: ClickEvent, isTranSet: boolean) {
        const target = event.target as Component;
        const tableRow: TableRow = TableRow.getContainingTableRow(target);
        const indexTable = tableRow.index
        EdiRawDataSlideout.openSlideout({title: 'Interchange Raw Data', interchangeId: this.interchangeId, isTranSet, indexTable, selectAllInterchange: false});
    }

    private setupLayout() {
        if (this.interchangeId) {
            this.sourceEdiTransSet.search({ interchange_id: this.interchangeId });
            this.sourceEdiFunctionalGrp.search({ interchange_id: this.interchangeId })
        }
        if (this.description) {
            this.labelDescriptionLogging.text = this.description;
        }
    }
    public setupLayoutByEdiLogId(){
        if (this.logId) {
            const interchangeId = this.sourceTransmissionControlList.data[0]?.get("edi_interchange.id");
            const descr = this.sourceTransmissionControlList.data[0]?.get("edi_log.descr");
            this.description = descr;
            this.interchangeId = interchangeId;
            this.setupLayout();
        }
    }
    public get interchangeId(): string {
        return this._interchangeId
    }

    public set interchangeId(v: string) {
        this._interchangeId = v;
    }

    public get logId(): string {
        return this._logId;
    }

    public set logId(v: string) {
        this._logId = v;
    }

    public get description(): string {
        return this._description;
    }

    public set description(v: string) {
        this._description = v;
    }

}
